// import api from './index'
import { axios } from '@/utils/request'

const API = {
  // login: 'b/student/studentApi/webCheckLogin', // 登录
  // webResign: 'b/student/studentApi/webResign', // 注册
  webResign: '/user/biz/student/pc/register', // 注册
  validatePass: 'b/student/studentApi/validatePass', // 重置密码
  // updateUserInfo: '/b/student/studentApi/changeMsg', // 修改头像昵称
  updateUserInfo: '/user/biz/student/pc/edit/myself', // 修改头像昵称
  // modifyPass: 'b/student/studentApi/modifyPass', // 修改密码
  modifyPass: '/user/biz/student/pc/change/password', // 修改密码
  login: 'auth/oauth/token', // 登录
  findStudyInfo: '/b/classes/stuInfo/findStudyInfo', // 获取学习时常，做作业，问答信息
  findStudyInfoV2: '/b/classes/stuInfo/v2/findStudyInfo', // 获取学习时常，做作业，问答信息
  studyPlanList: '/b/classes/biz/studentPlanclasses/v2/list', // 获取学员所有的班级
  weekStudyPlan: '/b/classes/study/plan/getSchedule/week', // 获取一周内学习计划统计数
  weekStudyPlanV2: '/b/classes/study/plan/v2/getSchedule/week', // 获取一周内学习计划统计数
  getOpenSchedulePage: '/b/classes/study/plan/getOpenSchedulePage', // 获取公开课分页
  getOpenSchedulePageV2: '/b/classes/study/plan/v2/getOpenSchedulePage', // 获取公开课分页
  getScheduleList: '/b/classes/study/plan/v2/getScheduleList/date', // 获取某天课次信息
  getClassesList: '/b/classes/biz/studentClasses/getList', // 获取学员所有课程
  getClassesListV2: '/b/classes/biz/studentClasses/v2/getList', // 获取学员所有课程
  // getStuInfo: '/b/student/student/currentInfo', // 获取学员信息
  getStuInfo: '/user/biz/student/pc/get/myself', // 获取学员信息
  getClassesTypes: '/b/classes/my/interest/classesTypes', // 兴趣爱好
  setClassesTypes: '/b/classes/my/interest/classesTypes', // 保存兴趣爱好
  getClassesTypesV2: '/b/classes/my/v2/interest/classesTypes', // 兴趣爱好
  setClassesTypesV2: '/b/classes/my/v2/interest/classesTypes', // 保存兴趣爱好
  sendOldPhoneNumber: '/user/biz/student/pc/change/phoneNumber/sms/old', // 发送更换手机号旧号短信验证码
  verifyOldPhoneNumber: '/user/biz/student/pc/change/phoneNumber/sms/old/check' // 验证更换手机号旧号短信验证码
}

// 登录
export const login = data => {
  return axios({
    url: API.login,
    method: 'POST',
    params: data,
    headers: {
      Authorization: 'Basic ZGV2OmRldg=='
    }
  })
}
// 手机号密码登录
export const pwdLogin = data => {
  return axios({
    url: '/user/biz/student/pc/passLogin',
    method: 'POST',
    data
    // headers: {
    //   Authorization: 'Basic ZGV2OmRldg=='
    // }
  })
}
// 短信验证码登录
export const verifyCodeLogin = data => {
  return axios({
    url: '/user/biz/student/pc/smsLogin',
    method: 'POST',
    data
    // headers: {
    //   Authorization: 'Basic ZGV2OmRldg=='
    // }
  })
}

export const getStuInfo = params => {
  return axios({
    url: API.getStuInfo,
    method: 'GET',
    params
    // headers: {
    //   'token': params,
    //   'Authorization': 'Basic ZGV2OmRldg==' + params
    //   // oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    // }
  })
}
// 注册
export const resign = data => {
  return axios({
    url: API.webResign,
    method: 'POST',
    // headers: {
    //   ocode: 'accdev',
    //   // oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    // },
    data
  })
}
// 重置密码
export const resset = data => {
  return axios({
    url: API.validatePass,
    method: 'POST',
    // headers: {
    //   ocode: 'accdev',
    //   // oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    // },
    data
  })
}
// 修改个人资料
export const updateUserInfo = data => {
  return axios({
    url: API.updateUserInfo,
    method: 'POST',
    data
    // headers: {
    //   ocode: 'accdev',
    //   // oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    // }
  })
}
// 修改密码
export const modifyPass = data => {
  return axios({
    url: API.modifyPass,
    method: 'POST',
    // headers: {
    //   ocode: 'accdev',
    //   // oid: '9e21b8650c474f3abd1fcf2b7b7e869f'
    // },
    data
  })
}

// 获取个人学习时常，做作业，问答信息
export const feachStudyInfo = () => {
  return axios({
    url: API.findStudyInfoV2,
    method: 'GET'
  })
}

// // 获取学员所有的班级
export const studyPlanList = () => {
  return axios({
    url: API.studyPlanList,
    method: 'GET'
  })
}
// 获取一周内学习计划统计数
export const feachWeekStudyPlan = data => {
  return axios({
    url: API.weekStudyPlanV2,
    method: 'POST',
    data: data
  })
}
// 获取某天的课次信息
export const getScheduleList = params => {
  return axios({
    url: API.getScheduleList,
    method: 'GET',
    params
  })
}
// 获取公开课
export const getOpenSchedulePage = params => {
  return axios({
    url: API.getOpenSchedulePageV2,
    method: 'GET',
    params
  })
}

export const getClassesList = () => {
  return axios({
    url: API.getClassesListV2,
    method: 'GET'
    // headers: {
    //   ocode: 'accdev',
    //   oid: '312523cacd5176057e7f3dd97a212d79'
    // },
  })
}

export const getClassesTypes = params => {
  return axios({
    url: API.getClassesTypesV2,
    method: 'GET',
    params
  })
}
export const setClassesTypes = data => {
  return axios({
    url: API.setClassesTypesV2,
    method: 'POST',
    data
  })
}
/**
 * 发送更换手机号旧号短信验证码
 */
export const sendOldPhoneNumber = () => {
  return axios({
    url: API.sendOldPhoneNumber,
    method: 'POST'
  })
}
/**
 * 发送更换手机号新号短信验证码
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.phoneNumber // 手机号码
 * @param { String } data.resetToken // 短信验证码
 */
export const sendNewPhoneNumber = data => {
  return axios({
    url: '/user/biz/student/pc/change/phoneNumber/sms/new',
    method: 'POST',
    data
  })
}

/**
 * 验证更换手机号旧号短信验证码
 * @param { Object } data
 * @param { String } data.smsCode
 */
export const verifyOldPhoneNumber = data => {
  return axios({
    url: API.verifyOldPhoneNumber,
    method: 'POST',
    data
  })
}
/**
 * 验证更换手机号新号短信验证码
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.phoneNumber // 手机号码
 * @param { String } data.resetToken // 短信验证码
 */
export const verifyNewPhoneNumber = data => {
  return axios({
    url: '/user/biz/student/pc/change/phoneNumber/sms/new/check',
    method: 'POST',
    data
  })
}
/**
 * 微信扫码登录获取登录串
 */
export const getWxLoginString = () => {
  return axios({
    url: '/user/biz/student/pc/getQrCodeLoginParam',
    method: 'GET'
  })
}
/**
 * 微信扫码登录
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.code  // 微信回调的code
 */
export const wxLogin = data => {
  return axios({
    url: '/user/biz/student/pc/qrCodeLogin',
    method: 'POST',
    data
  })
}
/**
 * 学员绑定微信
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.code  // 微信回调的code
 */
 export const bindWechat = data => {
  return axios({
    url: '/user/biz/student/pc/security/info/bind/wechat',
    method: 'POST',
    data
  })
}
/**
 * 换绑微信
 * @param { Object } data
 * @param { String } data.ocode // 机构编码
 * @param { String } data.code  // 微信回调的code
 */
 export const changebindWechat = data => {
  return axios({
    url: '/user/biz/student/pc/security/info/change/wechat',
    method: 'POST',
    data
  })
}
